// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3n3Cu","amount":"Amount_amount__3AAoF","tip":"Amount_tip__2lz-s","tipHeader":"Amount_tipHeader__3dz2A","tipsWrap":"Amount_tipsWrap__1FicF"};